import { useEffect, useState } from 'react'

import { selectStatus, useGenerationStatus } from 'Pods/Shared/GenerationStatus'

import { EMPTY_ARRAY } from 'Utils/stableDefaults'

const selectLastResult = (state) => state.lastResult
const selectLastResults = (state) => state.lastResults || EMPTY_ARRAY
const selectActiveRunCount = (state) => state.activeRunCount || 0
const selectUserId = (state) => state.userId

// Live 3D-model generation status (idle | generating | enhancing | succeeded | failed)
// and the finished-run projection, narrowed to the viewer who actually owns the run.
//
// Two guards, both required for the site-wide nav:
// - localStorage is shared across every user of this browser, so a run is only surfaced
//   to the account that started it - never a later anon visitor or a different login.
//   Both ids are normalized to strings (see resolveViewerId) and the compare is
//   fail-closed: an unresolved viewer (null) withholds the run rather than leaking it.
// - the store rehydrates from localStorage synchronously on the client, so a returning
//   user mid-run would hydrate different markup than the idle server render. The
//   post-mount flag keeps the first client render equal to SSR, then the real status
//   refines it in place (same 20px glyph box, so no layout shift).
export default function useOwnedGeneration(currentUserId) {
  const storeStatus = useGenerationStatus(selectStatus)
  const storeLastResult = useGenerationStatus(selectLastResult)
  const storeLastResults = useGenerationStatus(selectLastResults)
  const storeActiveRunCount = useGenerationStatus(selectActiveRunCount)
  const ownerUserId = useGenerationStatus(selectUserId)
  const [hydrated, setHydrated] = useState(false)

  useEffect(() => {
    setHydrated(true)
  }, [])

  const ownedByViewer = currentUserId != null && ownerUserId != null
    && String(ownerUserId) === String(currentUserId)
  const owned = hydrated && ownedByViewer

  return {
    status: owned ? storeStatus : undefined,
    lastResult: owned ? storeLastResult : null,
    lastResults: owned ? storeLastResults : EMPTY_ARRAY,
    activeRunCount: owned ? storeActiveRunCount : 0,
  }
}
